import api from "@/utils/http";

export * from './type'

/**
 功能：
 time: 2026/1/7 11:44
 **/
export function getExpenseConfig() {
    return api.get('/partner/expense/getSetConfig')
}

/**
 功能：
 time: 2026/1/7 11:44
 **/
export function getExpenseList(data) {
    return api.post('/partner/expense/getList', data)
}
/**
 * 功能：
 * @author Mr Wang
 * @date 2026/3/9 20:59
 */
export function getExpenseLists(data) {
    return api.post('/partner/expense/getLists', data)
}

/**
 功能：
 time: 2026/3/9 16:55
 **/
export function getExpenseStatic(data) {
    return api.post('/partner/expense/getStaticData', data)
}

/**
 功能：
 time: 2026/3/9 13:59
 **/
export function getExpenseBindList(data) {
    return api.post('/partner/expense/getBindList', data)
}

/**
 功能：
 time: 2026/1/7 12:02
 **/
export function saveExpense(data) {
    return api.post('/partner/expense/eSave', data)
}

/**
 功能：
 time: 2026/1/7 12:05
 **/
export function getExpenseDetail(id) {
    return api.post('/partner/expense/getDetail', {id })
}

/**
 功能：
 time: 2026/1/7 14:11
 **/
export function deleteExpense(id) {
    return api.post('/partner/expense/del', {id})
}

/**
 功能：
 time: 2025/12/27 11:01
 **/
export function examineExpense(data) {
    return api.post('/partner/expense/examineSave', data)
}

/**
 功能：
 time: 2025/12/27 11:47
 **/
export function payExpense(data) {
    return api.post('/admin/expense/paySave', data)
}

/**
 功能：
 time: 2026/5/13 16:25
 **/
export function exportExpenseProject(data) {
    return api.post('/partner/expense/exportExpenseProject', data)
}

/**
 功能：
 time: 2026/5/13 16:25
 **/
export function exportExpenseMy(data) {
    return api.post('/partner/expense/exportExpenseMy', data)
}